import { AuthenticationLoadingLayout } from "#src/batteries-included-components/Layouts/Authentication/AuthenticationLoading";
import {
  EmptyState,
  EmptyStateProps,
  Icon,
} from "@validereinc/common-components";
import React from "react";
import classNames from "classnames/bind";
import styles from "./ErrorOnLoginCallback.module.scss";

const cx = classNames.bind(styles);

export const ErrorOnLoginCallbackLayout = ({
  action,
}: Pick<EmptyStateProps, "action">) => {
  return (
    <AuthenticationLoadingLayout>
      <EmptyState
        title="Login Failed"
        suggestion={({ className }) => (
          <div className={cx("description-container")}>
            <p className={className}>
              There is an issue preventing your account from logging in,
              possibly due to a configuration or security setting. If the issue
              continues, contact{" "}
              <a href="mailto:support@validere.com">Validere Support</a> for
              assistance.
            </p>
          </div>
        )}
        variant="error"
        size="large"
        icon={<Icon variant="file-x" />}
        action={action}
      />
    </AuthenticationLoadingLayout>
  );
};
